import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import {
  ConditionalRenderer,
  Header,
  useLanguageTranslator,
} from "../../../../components";
import { useLocation } from "react-router-dom";
import { SubmissionTable } from "../features/adminView/table";
import { gql } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import { DownArrowIcon } from "../../../../@lib/icons";
import { useState } from "react";

const policyDocument = gql`
  query ($limit: Int, $page: Int) {
    pendingPolicies(limit: $limit, page: $page) {
      collection {
        country {
          name
        }
        createdAt
        date
        description
        document {
          source
          originalFilename
        }
        geographicalArea {
          name
        }
        id
        link
        picture {
          source
          originalFilename
        }
        policyCategory {
          name
        }
        status
        statusLabel
        theme {
          title
        }
        title
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const pendingPracticeDocument = gql`
  query ($limit: Int, $page: Int) {
    pendingPractices(limit: $limit, page: $page) {
      collection {
        country {
          name
        }
        createdAt
        date
        description
        document {
          source
          originalFilename
        }
        id
        link
        picture {
          source
          originalFilename
        }
        policy {
          title
        }
        practiceCategory {
          name
        }
        practiceType {
          name
        }
        status
        statusLabel
        theme {
          title
        }
        title
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const pendingPeopleDocument = gql`
  query ($limit: Int, $page: Int) {
    pendingPeople(limit: $limit, page: $page) {
      collection {
        country {
          name
        }
        createdAt
        firstname
        id
        lastname
        picture {
          source
          originalFilename
        }
        status
        statusLabel
        title
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

function isModule(location: any) {
  const isPractices = location?.pathname?.includes("practices") || false;
  const isPolicies = location?.pathname?.includes("policies") || false;
  if (isPolicies) {
    return {
      queryDocument: policyDocument,
      createPath: "/admin/policies/new",
      viewPath: "/admin/policies/",
    };
  } else if (isPractices) {
    return {
      queryDocument: pendingPracticeDocument,
      createPath: "/admin/practices/new",
      viewPath: "/admin/practices/",
    };
  } else {
    return {
      queryDocument: pendingPeopleDocument,
      createPath: "/admin/people/new",
      viewPath: "/admin/person_detail?id=",
    };
  }
}

function AdminPendingSubmissionALL() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [limit, setLimit] = useState(8);

  const location = useLocation();
  const { translator } = useLanguageTranslator();

  const { queryDocument, createPath, viewPath }: any = isModule(location);

  const { data: pending } = useApolloQuery({
    queryDocument: queryDocument,
    isPrivateCall: true,
    variables: {
      limit: limit,
      page: page,
    },
  });

  function onClickHandler() {
    const scrollPosition = window.scrollY;
    setLimit(limit + 8);

    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 0);
  }

  const metadata =
    pending?.pendingPolicies?.metadata ||
    pending?.pendingPractices?.metadata ||
    pending?.pendingPeople?.metadata;

  const hasMore =
    limit === metadata?.totalCount ||
    limit > metadata?.totalCount ||
    !metadata?.totalCount;

  return (
    <>
      <Header
        title={translator("Admin Area")}
        subtitle=""
      />
      <Container sx={{ my: 3 }}>
        <Paper component={Container} sx={{ py: 3 }}>
          <Stack
            direction={{ lg: "row" }}
            gap={2}
            justifyContent={{ lg: "space-between" }}
            alignItems={{ lg: "center" }}
          >
            <Box>
              <Typography variant="h4">
                {translator("Students Submissions")}
              </Typography>
            </Box>
            <Box>
              <Button
                href={createPath}
                sx={{
                  px: 6,
                  backgroundColor: "#F6A000",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "primary.light",
                  },
                }}
              >
                {translator("generic.CREATE")}
              </Button>
            </Box>
          </Stack>
          <SubmissionTable
            data={
              pending?.pendingPolicies?.collection ||
              pending?.pendingPractices?.collection ||
              pending?.pendingPeople?.collection ||
              []
            }
            metadata={
              pending?.pendingPolicies?.metadata ||
              pending?.pendingPractices?.metadata ||
              pending?.pendingPeople?.metadata ||
              {}
            }
            isAllShow
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={setPage}
            viewPath={viewPath}
          />
          <ConditionalRenderer condition={!hasMore}>
            <div
              style={{
                margin: "10px 0px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button style={{ color: "#979da7" }} onClick={onClickHandler}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {translator("Show more")} <DownArrowIcon />
                </div>
              </Button>
            </div>
          </ConditionalRenderer>
        </Paper>
      </Container>
    </>
  );
}

export { AdminPendingSubmissionALL };
